import React from "react";
import "./BlogSection.css";

const blogs = [
  {
    id: "01",
    category: "Airport Transfer",
    title: "Pune to Mumbai Airport Cab",
    description:
      "Travel comfortably from Pune to Mumbai Airport with Garud Cabs. Enjoy clean cars, professional drivers and a smooth airport transfer experience.",
    image: "/images/keyword/1.jpg",
    link: "/pune-to-mumbai-airport-cab-service",
  },
  {
    id: "02",
    category: "Weekend Escape",
    title: "Pune to Lonavala Cab",
    description:
      "Plan a refreshing Lonavala getaway with Garud Cabs. Travel through scenic roads and enjoy a comfortable journey with family and friends.",
    image: "/images/keyword/4.jpg",
    link: "/pune-to-lonavala-cab-service",
  },
  {
    id: "03",
    category: "Outstation Journey",
    title: "Pune to Goa Cab Service",
    description:
      "Make your Pune to Goa road trip comfortable and memorable with Garud Cabs. A convenient cab option for families, couples and group travel.",
    image: "/images/keyword/12.jpg",
    link: "/Pune-to-Goa-Cab-Service",
  },
];

const BlogSection = () => {
  return (
    <section className="garud-blog">
      <div className="garud-blog__glow garud-blog__glow--one"></div>
      <div className="garud-blog__glow garud-blog__glow--two"></div>

      <div className="garud-blog__container">
        {/* Heading */}
        <div className="garud-blog__heading">
          <div>
            <span className="garud-blog__eyebrow">
              <span></span>
              POPULAR JOURNEYS
            </span>

            <h2>
              Explore Popular
              <br />
              <strong>Cab Routes From Pune</strong>
            </h2>
          </div>

          <p>
            Discover comfortable airport transfers, weekend escapes and
            outstation journeys with Garud Cabs.
          </p>
        </div>

        {/* Blog Cards */}
        <div className="garud-blog__grid">
          {blogs.map((blog) => (
            <article className="garud-card" key={blog.id}>
              <a href={blog.link} className="garud-card__image">
                <img src={blog.image} alt={blog.title} />

                <div className="garud-card__overlay"></div>

                <span className="garud-card__number">{blog.id}</span>

                <span className="garud-card__category">
                  {blog.category}
                </span>
              </a>

              <div className="garud-card__content">
                <h3>
                  <a href={blog.link}>{blog.title}</a>
                </h3>

                <p>{blog.description}</p>

                <a href={blog.link} className="garud-card__link">
                  Explore Journey
                  <span>→</span>
                </a>
              </div>
            </article>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="garud-blog__cta">
          <div>
            <span>TRAVEL WITH GARUD CABS</span>
            <h3>Your Next Journey Starts Here.</h3>
            <p>
              Comfortable Cars • Professional Drivers • Outstation Travel
            </p>
          </div>

          <a href="/services" className="garud-blog__cta-btn">
            View All Cab Services
            <span>→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;